import React from 'react';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none',
  {
    variants: {
      variant: {
        default: 'bg-primary text-white hover:bg-primary/90 focus-visible:ring-primary',
        accent: 'bg-accent text-white hover:bg-accent/90 focus-visible:ring-accent',
        danger: 'bg-red-500 text-white hover:bg-red-600 focus-visible:ring-red-500',
        outline: 'border border-primary text-primary hover:bg-primary/10 focus-visible:ring-primary',
        ghost: 'hover:bg-primary/10 text-primary hover:text-primary focus-visible:ring-primary',
      },
      size: {
        // Uprava velkosti pre podporu dynamickej vysky podla obsahu
        // Odstranene pevne vysky (h-X) a pridane min-height pre minimalnu vysku tlacidla
        default: 'min-h-[40px] py-2 px-4',
        sm: 'min-h-[36px] py-1.5 px-3',
        lg: 'min-h-[44px] py-2.5 px-8',
        icon: 'min-h-[40px] min-w-[40px] p-2',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, children, ...props }, ref) => {
    return (
      <button
        className={twMerge(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";

export { Button, buttonVariants };
